/**
 * Canonical KCG product list. Must stay identical to the Salesforce product
 * catalogue so product names match across KCG Connect, Salesforce and Xero.
 * New products are added here and in Salesforce, never captured as free text.
 */
export const PEANUT_PRODUCT_PRESETS = [
  'Raw Split Grade 1 BG',
  'Raw Split Grade 1 BM',
  'Raw Split Grade 2 BG',
  'Raw Split Grade 2 BM',
  'Blanched Split Grade 1 BG',
  'Blanched Split Grade 1 BM',
  'Blanched Split Grade 2 BG',
  'Blanched Split Grade 2 BM',
  'Blanched 40/50',
  'Blanched 50/60',
  'Roasted Split',
  'Raw 38/42 Grade 1',
  'Raw 38/42 Grade 2',
  'Raw 40/50 Grade 1',
  'Raw 40/50 Grade 2',
  'Raw 50/60 Grade 1',
  'Raw 50/60 Grade 2',
  'Raw 60/70 Grade 1',
  'Raw 60/70 Grade 2',
  'Raw 80/100 Grade 1',
  'Raw 80/100 Grade 2',
] as const

export function getAllPeanutProductOptions(): string[] {
  return [...PEANUT_PRODUCT_PRESETS]
}

export function filterPeanutProductOptions(query: string): string[] {
  const q = query.trim().toLowerCase()
  const all = getAllPeanutProductOptions()
  if (!q) return all
  return all.filter((option) => option.toLowerCase().includes(q))
}

export function isPeanutProductOption(value: string): boolean {
  const trimmed = value.trim().toLowerCase()
  if (!trimmed) return false
  return getAllPeanutProductOptions().some((p) => p.toLowerCase() === trimmed)
}
